RivalIQ.apps.Dashboard.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    const nonSwitchableChannels = [];

    function isNotSwitchable(channel) {
        return _.includes(nonSwitchableChannels, _.get(channel, ['id']));
    }

    mixins.Switchable = {
        titleView: function () {
            const me = this;
            if (isNotSwitchable(me.getChannel())) {
                return me.getTitle();
            }
            return me.getSwitchableTitleView();
        },

        getSwitchableTitle: function () {
            const me = this;
            return me.getTitle();
        },

        getSwitchableTitleView: function (options) {
            const me = this;
            const title = me.getSwitchableTitle();
            const collectionItems = me.getSwitchableItems();
            return new RivalIQ.views.TitleDropdown({
                model: new Backbone.Model(_.extend({
                    name: title
                }, options)),
                collection: new Backbone.Collection(collectionItems)
            });
        }
    };

    mixins.ChannelSwitchable = _.defaults({
        // For static uses - filenames, etc
        title: function () {
            const me = this;
            return me.page().name;
        },

        page: function () {
            const me = this;
            return RivalIQ.configuration.menus.getPageByChannel(me.getChannel().getPathName());
        },

        getSwitchableTitle: function () {
            const me = this;
            return me.getChannel().getChannelName();
        },

        getSwitchableItems: function () {
            const me = this;
            return me.getChannels().reject(isNotSwitchable).map(function (channel) {
                return {
                    value: channel.getPathName(),
                    display: channel.getChannelName(),
                    action: function () {
                        if (RivalIQ.state.account.trialExpired()) {
                            return;
                        }

                        const options = me.getChannelPathOptions(channel);
                        const path = me.getPath(options);
                        RivalIQ.execute('history:navigate', path, {
                            trigger: true
                        });
                    }
                };
            });
        },

        getChannel: function () {
            const me = this;
            const channel = (me.getProp('channel') || RivalIQ.enums.sources.CROSS_CHANNEL);
            return RivalIQ.data.channels.get(channel);
        },

        getChannels: function () {
            return RivalIQ.data.channels.withChannelCuration()
                .withAccess()
                .notHidden(true);
        },

        getChannelPathOptions: function (channel) {
            return {
                channel: (channel.isCrossChannel() ? undefined : channel.getPathName())
            };
        },

        processProps: function (props) {
            // NOTE during Facebook OAuth redirect we receive a security hash
            // that looks like a channel, we need to strip it to use
            // cross-channel instead (#11404)
            const channel = _.get(props, 'channel');
            if (channel === '_=_') {
                props.channel = undefined;
            }

            return props;
        }
    }, mixins.Switchable);

    mixins.CompanySwitchable = _.defaults({
        titleView: function () {
            const me = this;
            return me.getSwitchableTitleView();
        },

        title: function () {
            const me = this;
            return me.page.name;
        },

        getSwitchableTitle: function () {
            const me = this;
            return RivalIQ.str('company_profile_title', me.company.get('name'));
        },

        getSwitchableItems: function () {
            const me = this;
            return me.companies.map(function (company) {
                return {
                    value: company.id,
                    display: company.get('name'),
                    action: function () {
                        const path = me.getPath({
                            companyId: company.id
                        });
                        RivalIQ.execute('history:navigate', path, {
                            trigger: true
                        });
                    }
                };
            });
        },

        getSwitchableTitleView: function () {
            const me = this;

            // NOTE if the curation does not have a company property then
            // we know we need to load one; this can occur when viewing
            // a followed company in another landscape
            if (!me.company) {
                const View = RivalIQ.views.TitleDropdown.extend({
                    loadData: function () {
                        const view = this;

                        // NOTE omit channel so that hidden channels dont
                        // result in zero returned results
                        const props = _.omit(me.getProps(), 'channel');
                        return RivalIQ.data.companyData.fetch(props)
                            .then(function (companyData) {
                                view.model = companyData.get(props.companyId);
                            });
                    }
                });

                return new View({
                    collection: new Backbone.Collection(me.getSwitchableItems())
                });
            }

            return mixins.Switchable.getSwitchableTitleView.apply(me, arguments);
        }
    }, mixins.Switchable);

});
